import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { UpcomingeventsRoutingModule } from './upcomingevents-routing.module';
import { UpcomingeventsListComponent } from './upcomingevents-list/upcomingevents-list.component';
import { UpcomingeventsCreateComponent } from './upcomingevents-create/upcomingevents-create.component';

@NgModule({
  declarations: [UpcomingeventsListComponent, UpcomingeventsCreateComponent],
  imports: [
    CommonModule,
    UpcomingeventsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class UpcomingeventsModule { }
